import { useContext, useEffect, useMemo, useRef } from "react";
import { SettingsContext, ShopContext, TableContext, AlertContext } from "../App";
import Label from "./Label";
import "../css/Pin.css";

// Lista tavoli per l'operatore (modalità tablet): l'app cameriere incorporata in iframe.
// Protocollo postMessage (vedi waiter-app/src/embed.js):
//   iframe -> "ready"       -> rispondiamo con il token operatore (solo all'origine dell'iframe)
//   iframe -> "table-open"  -> il tavolo è aperto/ripreso: il tablet passa al cliente
function StaffTablesFrame() {
  const { settings, staff, setStaff, tabletEnterTable } = useContext(SettingsContext);
  const { shop } = useContext(ShopContext);
  const { load_table } = useContext(TableContext);
  const { setAlertData } = useContext(AlertContext);
  const frameRef = useRef(null);

  const frameSrc = useMemo(() => {
    const base = settings?.mandant?.url_waiter;
    if (!base) return "";
    return base + "/?embed=tablet&shop_id=" + encodeURIComponent(shop.id);
  }, [settings, shop]);
  const frameOrigin = useMemo(() => (frameSrc ? new URL(frameSrc).origin : ""), [frameSrc]);

  useEffect(() => {
    if (!frameSrc) return;
    const listener = async (event) => {
      if (event.origin !== frameOrigin) return;
      if (!frameRef.current || event.source !== frameRef.current.contentWindow) return;
      const data = event.data;
      if (!data || data.source !== "yellgo-waiter") return;

      if (data.type === "ready") {
        event.source.postMessage({ source: "yellgo-selforder", type: "auth", token: staff.token }, frameOrigin);
      } else if (data.type === "exit") {
        setStaff(false);
      } else if (data.type === "table-open" && data.table_id) {
        const table = await load_table(data.table_id);
        if (!table || table.status == 0 || table.single_order_mode == 1) {
          setAlertData({
            title: <Label number={70} />,
            message: "Tavolo non disponibile per la modalità tablet",
            confirmMessage: <Label number={31} />,
          });
          return;
        }
        tabletEnterTable(data.table_id);
      }
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [frameSrc, frameOrigin, staff]);

  if (!frameSrc) {
    return (
      <div id="pin" className="staff-tables-frame staff-tables-empty">
        <p>App cameriere non configurata per questo locale.</p>
        <button type="button" onClick={() => setStaff(false)}>
          Indietro
        </button>
      </div>
    );
  }

  return (
    <div id="pin" className="staff-tables-frame">
      <iframe
        ref={frameRef}
        src={frameSrc}
        title="Tavoli"
        referrerPolicy="origin"
        className="staff-tables-iframe"
      />
    </div>
  );
}

export default StaffTablesFrame;
